const elDescriptionsKey = "elDescriptions";

export { elDescriptionsKey };
//# sourceMappingURL=token.mjs.map
